import { useState, useEffect } from 'react';
import './Stories.css';

const slides = [
  { src: '/images/team_group.jpg', alt: 'Aranyakam on-ground team in Tamil Nadu', position: 'center center' },
  { src: '/images/carousel_felicitation1.jpg', alt: 'Farmer felicitation at Aranyakam facility', position: 'center top' },
  { src: '/images/carousel_pandi_quality.jpg', alt: 'Pandi quality chilli produce', position: 'center center', portrait: true },
  { src: '/images/carousel_perumal_nagaraja.jpg', alt: 'Nagaraja Perumal — farmer partner', position: 'center center' },
  { src: '/images/carousel_perumal_saravana.png', alt: 'Saravana Perumal — farmer partner', position: 'center 20%' },
  { src: '/images/carousel_ladies_working.jpg', alt: 'Women sorting chillies at the processing facility', position: 'center center' },
];

export default function Stories() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, 3800);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="stories" id="stories">
      <div className="stories-inner">
        <div className="stories-header">
          <p className="section-label">From the field</p>
          <h2 className="section-title">Stories from the ground.</h2>
          <div className="divider" />
        </div>

        <div className="stories-body">
          <div className="stories-carousel">
            <div className="stories-img-track">
              {slides.map((slide, i) => (
                <div key={i} className={`stories-slide ${i === current ? 'active' : ''}`}>
                  {slide.portrait && (
                    <img src={slide.src} alt="" aria-hidden="true" className="stories-img-bg" />
                  )}
                  <img
                    src={slide.src}
                    alt={slide.alt}
                    className={slide.portrait ? 'stories-img-fg' : 'stories-img-cover'}
                    style={{ objectPosition: slide.position }}
                  />
                </div>
              ))}
            </div>
            <div className="stories-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={`stories-dot ${i === current ? 'active' : ''}`}
                  onClick={() => setCurrent(i)}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="stories-text">
            <h3 className="stories-text-heading">It's all about people.</h3>
            <p className="stories-text-body">
              Behind every kilo of spice we ship is a farmer who trusted us,
              a young person whose skills we helped shape, and a woman who found new economic footing
              through our network.
            </p>
            <p className="stories-text-body">
              We are actively working on documenting and sharing the stories of the farming communities,
              rural youth, and women groups that are part of the Aranyakam ecosystem —
              because we believe these stories deserve to be heard.
            </p>
            <p className="stories-text-footer">
              Stay tuned for updates — more coming soon.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
